import { db, auth } from "../firebase/config";
import { collection, getDoc, doc, onSnapshot } from "firebase/firestore";
import { Button, Form } from "react-bootstrap"; // Import Bootstrap Button component
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";



export function RolesDragdown() {
    const [roles, setRoles] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {

        rolesConfig()

    }, []);
    async function rolesConfig() {
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, "users", user.uid);

            // Fetch initial data first
            const userSnapshot = await getDoc(userDocRef);
            if (userSnapshot.exists()) {
                setRoles(userSnapshot.data().role || []);
                console.log("from usersnapshot", userSnapshot.data().role)
            }

            // Setup real-time listener
            return onSnapshot(userDocRef, (doc) => {
                if (doc.exists()) {
                    setRoles(doc.data().role || []);
                    console.log("from firestore", doc.data().role)
                }
            });
        }
    }



    function roleNavigation(rolesArray, index) {
        if (rolesArray[index] === "Admin") {
            console.log("Admin clicked")
            navigate("/administratorDashboard");
        } else if (rolesArray[index] === "Faculty") {
            console.log("Faculty clicked")
            navigate("/faculty/dashboard");
        } else if (rolesArray[index] === "Proctor") {
            console.log("Proctor clicked")
            navigate("/proctorDashboard");
        } else if (rolesArray[index] === "Instructor") {
            console.log("Instructor clicked")
            navigate("/instructorDashboard");
        } else if (rolesArray[index] === "Student") {
            console.log("Student clicked")
            navigate("/studentDashboard");
        } else {
            return
        }


    }

    function displayRole() {
        return roles.map((role, index) => (

            <Dropdown.Item key={index} onClick={() => roleNavigation(roles, index)}>
                {role} dashboard
            </Dropdown.Item>
        ));
    }

    return (
        <div className="text-end mb-3">
        <DropdownButton
            onClick={() => rolesConfig()}
            title="Switch Roles"
            id="bg-nested-dropdown"
            variant = "success"
        >
            {displayRole()}
            {/* <a href="google.com" style={{ display: "block" }}>Apply for new role</a> */}
        </DropdownButton>
    </div>

         
      
    );
}
